import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { AdvancedSearchParameter, AdvancedSearchService } from "../advanced-search.service";

@Component({
    selector: "advanced-search-color",
    imports: [NgClass, SvgIconComponent],
    templateUrl: "./advanced-search-color.component.html",
    styleUrl: "./advanced-search-color.css"
})
export class AdvancedSearchColorComponent {
    @Input({ required: true }) public type!: AdvancedSearchParameter;
    
    public logicalAnd: boolean = false;               // If false, then logical mode is OR. If true, then logical mode is AND.
    public hasValue: boolean = false;
    public closeSvgIcon: SvgIcon = SvgIcon.Close;

    public white: boolean = false;
    public blue: boolean = false;
    public black: boolean = false;
    public red: boolean = false;
    public green: boolean = false;
    public colorless: boolean = false;
    
    public constructor(private advancedSearch: AdvancedSearchService) {

    }

    public onClear(): void {
        this.white = false;
        this.blue = false;
        this.black = false;
        this.red = false;
        this.green = false;
        this.colorless = false;
        this.hasValue = false;
        this.advancedSearch.setColor(this.type, this.logicalAnd, this.white, this.blue, this.black, this.red, this.green, this.colorless);
    }

    public onToggleLogicalMode(): void {
        this.logicalAnd = !this.logicalAnd;
        this.advancedSearch.setColor(this.type, this.logicalAnd, this.white, this.blue, this.black, this.red, this.green, this.colorless);
    }

    public onToggleWhite(): void {
        this.white = !this.white;
        this.hasValue = this.white || this.blue || this.black || this.red || this.green || this.colorless;
        this.advancedSearch.setColor(this.type, this.logicalAnd, this.white, this.blue, this.black, this.red, this.green, this.colorless);
    }

    public onToggleBlue(): void {
        this.blue = !this.blue;
        this.hasValue = this.white || this.blue || this.black || this.red || this.green || this.colorless;
        this.advancedSearch.setColor(this.type, this.logicalAnd, this.white, this.blue, this.black, this.red, this.green, this.colorless);
    }

    public onToggleBlack(): void {
        this.black = !this.black;
        this.hasValue = this.white || this.blue || this.black || this.red || this.green || this.colorless;
        this.advancedSearch.setColor(this.type, this.logicalAnd, this.white, this.blue, this.black, this.red, this.green, this.colorless);
    }

    public onToggleRed(): void {
        this.red = !this.red;
        this.hasValue = this.white || this.blue || this.black || this.red || this.green || this.colorless;
        this.advancedSearch.setColor(this.type, this.logicalAnd, this.white, this.blue, this.black, this.red, this.green, this.colorless);
    }

    public onToggleGreen(): void {
        this.green = !this.green;
        this.hasValue = this.white || this.blue || this.black || this.red || this.green || this.colorless;
        this.advancedSearch.setColor(this.type, this.logicalAnd, this.white, this.blue, this.black, this.red, this.green, this.colorless);
    }

    public onToggleColorless(): void {
        this.colorless = !this.colorless;
        this.hasValue = this.white || this.blue || this.black || this.red || this.green || this.colorless;
        this.advancedSearch.setColor(this.type, this.logicalAnd, this.white, this.blue, this.black, this.red, this.green, this.colorless);
    }
}